import { Input } from './styled'

export default Input
